/**
 * Created by mgoria on 7/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadUserException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when load user form db failed
 */
let LoadUserException = exports.LoadUserException = function (_Exception) {
  _inherits(LoadUserException, _Exception);

  /**
   * @param {String} identityId
   * @param {Object} error
   */
  function LoadUserException(identityId, error) {
    _classCallCheck(this, LoadUserException);

    return _possibleConstructorReturn(this, (LoadUserException.__proto__ || Object.getPrototypeOf(LoadUserException)).call(this, `Error on loading user ${identityId} from db. ${error}`));
  }

  return LoadUserException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/LoadUserException.js
// module id = 439
// module chunks = 0